// ── IP 관리 — 유틸 함수 + 상수 ────────────────────────────────────────────────

// 페이지당 표시 행 수
export const PAGE_SIZE = 10;
// 모바일 분기점 (px)
export const MOBILE_BREAKPOINT = 768;

/** 현재 화면이 모바일인지 여부 */
export function getIsMobile() {
  return typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT;
}

/**
 * IPv4-mapped IPv6 주소 접두사(::ffff:) 제거 후 정규화
 * 예) "::ffff:192.168.1.1" → "192.168.1.1"
 */
export function normalizeIp(ip) {
  if (!ip) return '';
  return String(ip).replace(/^::ffff:/, '').trim();
}

/** 루프백 IP 여부 (127.0.0.1 또는 ::1) */
export function isLoopbackIp(ip) {
  return ip === '127.0.0.1' || ip === '::1';
}

/**
 * IP 연결 행의 활성 여부
 * 과거 데이터 호환: is_active가 null/undefined인 기존 행은 활성으로 처리
 */
export function isActiveRow(row) {
  return row?.is_active !== false;
}

/**
 * IP 주소에 별칭이 있으면 "IP (별칭)" 형식으로 반환, 없으면 IP만 반환
 */
export function formatIpWithAlias(ip, alias) {
  const pureIp = normalizeIp(ip);
  const aliasText = String(alias || '').trim();
  if (!pureIp) return '-';
  if (!aliasText) return pureIp;
  return `${pureIp} (${aliasText})`;
}

/**
 * 직원/공용 등록 여부 조합에 따른 상태 텍스트 반환
 */
export function getStatusText(userRegistered, publicRegistered) {
  if (userRegistered && publicRegistered) return '직원/공용 등록';
  if (userRegistered) return '직원 전용 등록';
  if (publicRegistered) return '공용 등록';
  return '미등록';
}
